<template>
  <div class="about">
    <table class="about__data">
      <tr>
        <td>App Version</td>
        <td>{{ $store.getters.appVersion }}</td>
      </tr>
      <tr>
        <td>Backend Api Version</td>
        <td>{{ $store.getters.backendApiVersion }}</td>
      </tr>
      <tr>
        <td>Crm Api Version</td>
        <td>{{ $store.getters.reemApiVersion }}</td>
      </tr>
      <tr>
        <td>Cube Api Version</td>
        <td>{{ $store.getters.cubeApiVersion }}</td>
      </tr>
    </table>

    <div>
      Letzte Änderungen<br />
      <ul>
        <li>
          App: 2.2.0 (09.06.2021)
          <ul>
            <li>
              <strong>Filterfunktion</strong><br />
              Eine Filterfunktion wurde eingefügt, mit der Cubes nach Produktionstyp, Preis, Entfernung gefiltert werden können.
              <br>
              Die Listen-/Ergebnisansicht zeigt zudem an, ob man sich zu dem Produzenten noch verbinden kann, Preisdetails sowie Entfernung.
            </li>
            <li>
              <strong>Sortierfunktion</strong><br />
              Es gibt nun die Möglichkeit, die Produzenten nach Preis oder Entfernung zu sortieren.
            </li>
            <li>
              <strong>Neue Icons und Map Marker</strong><br />
              Es werden neue Icons verwendet, die die Zugehörigkeit zum Energieanbieter sowie den Produktionstyp besser erkennen lassen.
            </li>
            <li>
              <strong>Menüführung</strong><br />
              Das Hauptmenü und das Benachrichtigungs-Menü wurden zusammengefasst. Die Benachrichtigungen sind nun im Hauptmenü als eigener Listenmenüpunkt ersichtlich.
            </li>
            <li>
              <strong>Benachrichtigungen</strong><br />
              Benachrichtigungen werden jetzt einfach per Klick als gelesen markiert. Man muss nicht mehr exakt den roten Punkt treffen.
            </li>
          </ul>
        </li>
        <li>
          App: 2.1.3 (13.04.2021)
          <ul>
            <li>
              <strong>Passwort-Reset Fehler behoben</strong><br />
              Mail Versand erfolgt nun zeitnah (&lt;1 Minute). Zudem wird der
              Benutzer darauf hingewiesen, dass bereits ein Passwort-Rücksetzen
              Prozess im Gange ist und kann ihn binnen 5 Minuten nicht erneut
              starten.<br />
              Der Request nach dem Neu-Eingeben des Passworts bleibt nicht mehr
              hängen.
            </li>
            <li>
              <strong>Trading Daten</strong><br />
              Die Trading-Daten werden nun nicht mehr nur 4x täglich in der
              Ansicht aktualisiert, sondern öfter, mit Ziel viertelstündlich
              (Frequenz wird in den nächsten Wochen sukzessive erhöht). Das
              sorgt für mehr Transparenz und die eFriends sehen noch schneller,
              von wem sie Energie bekommen bzw. mit wem sie Energie teilen.
            </li>
            <li>
              <strong>Trading Daten für Produzenten</strong><br />
              Produzenten sehen jetzt auch die Summen ihrer eigenen Produktion
              sowie die Menge an Strom, die an die Community geht.
            </li>
            <li>
              <strong>Prioritätsänderungen</strong><br />
              Änderungen an der Priorität werden nun auch in der Oberfläche
              sofort dargestellt. Bisher war ein Browser-Refresh notwendig.
            </li>
            <li>
              <strong>Bezug von Spendenempfängern</strong><br />
              Fehlerhafte Darstellung, wenn man an eine karitative Einrichtung
              spendet und gleichzeitig auch von dort bezieht, wurde korrigiert.
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="about__icons">
      Diese App verwendet die wunderbaren Icons von
      <a href="https://fontawesome.com/" target="_blank">Font Awesome</a> (<a
        href="https://fontawesome.com/license"
        target="_blank"
        >Lizenz</a
      >).
    </div>
  </div>
</template>

<script>
  export default {
    name: 'about',
  }
</script>

<style lang="scss">
  .about {
    &__data {
      border: 1px solid $grey-light;
      border-collapse: collapse;
    }
  }
</style>
